import React from "react";
import { toast } from "react-toastify";
import "./toast.scss";

const success = (msg, { onClose = () => {}, autoClose = 4000 }) =>
  toast.success(<span>{msg}</span>, {
    className: "success",
    progressClassName: "success-bar",
    onClose: onClose,
    autoClose: autoClose,
  });

const error = (msg, { onClose = () => {}, autoClose = 4000 }) =>
  toast.error(<span>{msg}</span>, {
    className: "error",
    onClose: onClose,
    autoClose: autoClose,
  });
export { success, error };
